import React, { useRef, useEffect } from "react";
import Editor, { OnMount } from "@monaco-editor/react";
import { editor as MonacoEditor } from "monaco-editor";

interface CodeEditorProps {
  language: string;
  theme: string;
  value: string;
  onChange: (value: string) => void;
  isReadOnly?: boolean;
  height?: string;
}

const CodeEditor: React.FC<CodeEditorProps> = ({
  language,
  theme,
  value,
  onChange,
  isReadOnly,
  height = "100%",
}) => {
  const editorRef = useRef<MonacoEditor.IStandaloneCodeEditor | null>(null);

  const handleEditorDidMount: OnMount = (editor) => {
    editorRef.current = editor;
    editor.updateOptions({
      minimap: { enabled: true },
      automaticLayout: true,
      scrollBeyondLastLine: false,
      fontSize: 14,
      lineHeight: 22,
    });
    editor.onDidChangeModelContent(() => {
      if (editorRef.current) {
        onChange(editorRef.current.getValue());
      }
    });
  };

  useEffect(() => {
    return () => {
      editorRef.current?.dispose();
    };
  }, []);

  useEffect(() => {
    if (editorRef.current) {
      const model = editorRef.current.getModel();
      if (model && model.getValue() !== value) {
        editorRef.current.setValue(value);
      }
    }
  }, [value]);

  return (
    <div style={{ height: "100%", width: "100%", position: "relative" }}>
      <Editor
        height={height}
        width="100%"
        language={language}
        theme={theme}
        value={value}
        onMount={handleEditorDidMount}
        options={{
          readOnly: isReadOnly,
          scrollBeyondLastLine: false,
          automaticLayout: true,
        }}
      />
    </div>
  );
};

export default CodeEditor;
